import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceFailure } from 'app/core/device/failures/device-failure';
import { BasePaginatedResponse } from 'app/core/http/base-paginated-response';

@Injectable({providedIn: 'root'})
export class DeviceFailuresApi {

    /**
     * Constructor
     */
    constructor(private httpClient: HttpClient)
    {
    }

    getPaginated(paramsObj: object) {
        const filteredParams = Object.entries(paramsObj)
            .filter(([key, value]) => value !== undefined && value !== null)
            .map(([key, value]) => `${key}/${value}`);

        // Unir los parámetros para formar la URL
        const url = `api/v3/machines/failures/${filteredParams.join('/')}`;

        return this.httpClient.get<BasePaginatedResponse<DeviceFailure>>(url);
    }
    
    exportAsExcel(paramsObj: object) {
        const filteredParams = Object.entries(paramsObj)
            .filter(([key, value]) => value !== undefined && value !== null)
            .map(([key, value]) => `${key}/${value}`);

        // Unir los parámetros para formar la URL
        const url = `api/v3/machines/failures/export/xls/${filteredParams.join('/')}`;

        return this.httpClient.get(url, { responseType: 'blob' });
    }
}

